module.exports = __webpack_public_path__ + "f7b79806a67250a4e043c85ae0272713.svg";